const AD_ID_COOKIE = "ad_id";
const AD_ID_TTL_DAYS = 90;

// Matches the format Meta's own Pixel uses for _fbc:
//   fb.<subdomainIndex>.<creationTimeMs>.<fbclid>
// subdomainIndex = 1 for a bare domain like aome.co.jp. If the site ever
// moves to a subdomain (e.g. app.aome.co.jp), bump this to 2.
const FBC_SUBDOMAIN_INDEX = 1;
const FBC_TTL_DAYS = 90; // matches Meta's own _fbc lifetime

function setCookie(name, value, days) {
    const maxAgeSeconds = days * 24 * 60 * 60;
    // Secure + SameSite=Lax is a safe default for first-party attribution cookies.
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax; Secure`;
}
function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}


export function captureAdId() {

    const params = new URLSearchParams(window.location.search);
    const adId = params.get("ad_id");
    const fbclid = params.get("fbclid");

    if (adId) {
        setCookie(AD_ID_COOKIE, adId, AD_ID_TTL_DAYS);
    }

    // Build _fbc ourselves instead of relying solely on the Meta Pixel script.
    // The Pixel's own capture is async (network fetch of fbevents.js) and can
    // lose the race against a same-tick client-side redirect (e.g. a logged-in
    // user hitting <Navigate to="/dashboard" /> on landing) - by the time the
    // Pixel script is ready to read the URL, the redirect has already stripped
    // fbclid from it. Capturing synchronously here, before React/router even
    // mounts, avoids that race entirely.
    //
    // If the Pixel *also* manages to set _fbc before this runs, we simply
    // overwrite with an equivalent value derived from the same fbclid - no
    // conflict, since both are deriving from the same click.
    if (fbclid) {
        const fbc = `fb.${FBC_SUBDOMAIN_INDEX}.${Date.now()}.${fbclid}`;
        setCookie("_fbc", fbc, FBC_TTL_DAYS);
    }
}


export function getStoredAdId() {
    return getCookie(AD_ID_COOKIE);
}
export function getMetaCookies() {
    return {
        fbp: getCookie("_fbp"),
        fbc: getCookie("_fbc"),
    };
}


export function collectSignupAttribution() {
    const { fbp, fbc } = getMetaCookies();
    return {
        adId: getStoredAdId(),
        fbp,
        fbc,
    };
}